import React from 'react'
import PropTypes from 'prop-types'
import { Item, ShippingItem } from '.'
import { CatalogCurrencyLabel } from 'Shared/CurrencyLabel'

const SummaryOrder = ({ cart, children, currentPrice }) => {
  let { count, shipping } = cart
  let price = { cash: cart.priceCash, points: cart.price }
  let shippingPrice = { cash: shipping.totalCash, points: shipping.total }
  if (currentPrice) {
    let valorTotal = currentPrice.valorTotal > 0 ? currentPrice.valorTotal : cart.priceCash
    let shippingTotalPrice = shipping.totalCash
    price = { cash: (valorTotal - shippingTotalPrice), points: cart.price }
  }
  return (
    <div className='checkout-side col-12 col-lg-4 mb-3 mb-sm-0 mt-2 mt-lg-0 px-0 py-0'>
      <div className='col-12 border-ui-3 radius bg-white px-0 py-0 pb-2'>
        <div className='col-12 py-3 px-3 mx-0 border-color-ui-3 border-bottom'>
          <h2 className='color-title txt-font-body'>Resumo do pedido</h2>
        </div>
        <div className='col-12 pb-1 mx-0'>
          <Item
            description={`Subtotal (${count} itens):`}
            className='row product-brand py-2 px-2 border-dotted-bottom border-color-ui-3'
            classFont='txt-body-sm color-ui-2'
          >
            <CatalogCurrencyLabel price={price} checkCashOnly />
          </Item>
          {cart.hasItemsDifferentVirtualVoucher && (
            <ShippingItem price={shippingPrice} label='pontos' />
          )}
          {children}
        </div>
      </div>
    </div>
  )
}

SummaryOrder.propTypes = {
  cart: PropTypes.object.isRequired,
  children: PropTypes.array.isRequired,
  currentPrice: PropTypes.object
}

export default SummaryOrder



// WEBPACK FOOTER //
// ./src/features/SummaryOrder/SummaryOrder.js